import React, { useState, useRef, useEffect } from 'react';

const BUSINESS_CONTEXT = `
Negocio: Tiendas Colombia (calzado e-commerce), Trend Bird, Tokio Tienda
Plataforma: Shopify (más de 100,000 pedidos)
Mensajería: WhatsApp Business API (Meta), Instagram DMs, Facebook Messenger
Transportadoras: Coordinadora, Interrapidísimo
Pagos: COD (Releasit), ADDI, Sistecrédito, Mercado Pago, Tarjeta, Punto Efecty
Agentes IA: Tatiana Rojas (servicio al cliente IG/Messenger), Paola Escobar (recuperación WhatsApp)
Backend: Railway, n8n para automatizaciones
Tiendas Shopify: conectadas vía API (dominio dinámico por tenant)
Plantillas WhatsApp aprobadas: confirmacion_de_pedidos_2026
Ciudad base: Cúcuta, Colombia
Envíos: gratis, 2-4 días hábiles, cobertura nacional
`;

const SYSTEM_PROMPT = `Eres un experto en automatización de flujos para e-commerce colombiano. 
Tu tarea es generar flujos COMPLETOS y detallados para n8n basados en la descripción del usuario.

Contexto del negocio:
${BUSINESS_CONTEXT}

Cuando el usuario describa un flujo, debes responder con un JSON estructurado así:
{
  "nombre": "nombre del flujo",
  "tipo": "whatsapp|instagram|messenger|webhook|http|shopify",
  "tienda": "nombre de la tienda",
  "descripcion": "descripción corta",
  "nodos": [
    {
      "id": "nodo_1",
      "tipo": "trigger|condicion|accion|espera|fin",
      "nombre": "Nombre del nodo",
      "descripcion": "Qué hace este nodo",
      "config": { "param": "valor" },
      "siguiente": ["nodo_2"] 
    }
  ],
  "checklist": [
    {
      "paso": 1,
      "titulo": "Título del paso",
      "descripcion": "Qué debe hacer manualmente",
      "tipo": "api|configuracion|test|shopify|n8n",
      "obligatorio": true
    }
  ],
  "n8n_json": { "nodes": [], "connections": {} },
  "variables_requeridas": ["WHATSAPP_TOKEN", "SHOPIFY_API_KEY"],
  "estimado_configuracion": "30 minutos"
}

IMPORTANTE: 
- Genera flujos MUY detallados con todos los nodos necesarios
- El checklist debe ser paso a paso, específico para este negocio
- Incluye manejo de errores en los nodos
- Considera los horarios de atención colombianos
- Usa las plantillas y agentes reales del negocio
- Responde SOLO con el JSON, sin texto adicional ni backticks`;

const NODE_COLORS = {
  trigger:    { bg:'#f0fdf4', border:'#22c55e', dot:'#22c55e', label:'Trigger' },
  condicion:  { bg:'#fffbeb', border:'#f59e0b', dot:'#f59e0b', label:'Condición' },
  accion:     { bg:'#eff6ff', border:'#3b82f6', dot:'#3b82f6', label:'Acción' },
  espera:     { bg:'#f5f3ff', border:'#8b5cf6', dot:'#8b5cf6', label:'Espera' },
  fin:        { bg:'#f4f4f2', border:'#888',    dot:'#888',    label:'Fin' },
};

const CHECKLIST_ICONS = {
  api:          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>,
  configuracion:<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  test:         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  shopify:      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#5a8a00" strokeWidth="1.8" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/></svg>,
  n8n:          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ea580c" strokeWidth="1.8" strokeLinecap="round"><rect x="3" y="3" width="6" height="5" rx="1.5"/><rect x="15" y="9" width="6" height="5" rx="1.5"/><rect x="3" y="16" width="6" height="5" rx="1.5"/><path d="M9 5.5h3a3 3 0 0 1 3 3v3"/><path d="M9 18.5h3a3 3 0 0 0 3-3v-3"/></svg>,
};

const SUGERENCIAS = [
  "Cuando llegue un pedido COD en Shopify, enviar confirmación por WhatsApp y esperar respuesta del cliente",
  "Si Coordinadora reporta dirección incorrecta, notificar al cliente y pedir corrección automáticamente",
  "Cuando un cliente escriba 'cambio' o 'talla' en WhatsApp, iniciar proceso de cambio y asignar a Paola",
  "Si ADDI rechaza el crédito, ofrecer alternativa COD automáticamente con descuento",
  "Cuando el pedido esté entregado, enviar encuesta de satisfacción 24 horas después",
  "Si el cliente no responde en 2 horas al bot, escalar al agente humano",
];

export default function FlowAI({ onClose, onSave }) {
  const [step, setStep] = useState('chat'); // chat | result
  const [messages, setMessages] = useState([
    { role:'assistant', content:'Hola Daniel. Cuéntame qué flujo necesitas crear. Puedes describirlo en tus propias palabras — por ejemplo: *"Cuando llegue un pedido COD, quiero que le llegue un mensaje al cliente pidiendo confirmación y si no responde en 2 horas que me avise"*. Yo me encargo del resto.' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [flowResult, setFlowResult] = useState(null);
  const [checklistDone, setChecklistDone] = useState([]);
  const [activeTab, setActiveTab] = useState('diagrama');
  const [copied, setCopied] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => { messagesEndRef.current?.scrollIntoView({behavior:'smooth'}); }, [messages]);

  const sendMessage = async (text) => {
    if (!text.trim() || loading) return;
    const userMsg = { role:'user', content:text };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    try {
      const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 4000,
          system: SYSTEM_PROMPT,
          messages: newMessages.map(m => ({ role: m.role, content: m.content }))
        })
      });

      const data = await response.json();
      const rawText = data.content?.[0]?.text || '';

      // Intentar parsear JSON
      let parsed = null;
      try {
        const jsonMatch = rawText.match(/\{[\s\S]*\}/);
        if (jsonMatch) parsed = JSON.parse(jsonMatch[0]);
      } catch(e) {}

      if (parsed && parsed.nodos) {
        setFlowResult(parsed);
        setMessages(prev => [...prev, {
          role:'assistant',
          content:`Perfecto. Generé el flujo **"${parsed.nombre}"** con ${parsed.nodos?.length || 0} nodos y ${parsed.checklist?.length || 0} pasos de configuración. Revisa el resultado abajo.`
        }]);
        setStep('result');
      } else {
        setMessages(prev => [...prev, { role:'assistant', content: rawText }]);
      }
    } catch(e) {
      setMessages(prev => [...prev, { role:'assistant', content:'Hubo un error al conectar con la IA. Verifica tu conexión e intenta de nuevo.' }]);
    }
    setLoading(false);
  };

  const toggleChecklist = (i) => {
    setChecklistDone(prev => prev.includes(i) ? prev.filter(x=>x!==i) : [...prev, i]);
  };

  const copyJSON = () => {
    if (!flowResult) return;
    navigator.clipboard.writeText(JSON.stringify(flowResult.n8n_json || flowResult, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const completedSteps = checklistDone.length;
  const totalSteps = flowResult?.checklist?.length || 0;
  const progress = totalSteps > 0 ? Math.round((completedSteps/totalSteps)*100) : 0;

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:600,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:20,width:'92vw',maxWidth:1100,height:'90vh',display:'flex',flexDirection:'column',overflow:'hidden',boxShadow:'0 30px 80px rgba(0,0,0,0.3)'}} onClick={e=>e.stopPropagation()}>

        {/* HEADER */}
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'18px 24px',borderBottom:'1px solid #f0f0ee',flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <div style={{width:38,height:38,borderRadius:11,background:'linear-gradient(135deg,#6ee7b7,#3b82f6)',display:'flex',alignItems:'center',justifyContent:'center'}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><path d="M12 2a10 10 0 1 0 10 10"/><path d="M12 6v6l4 2"/><circle cx="18" cy="6" r="4" fill="#fff" stroke="none"/><path d="M16 6h4M18 4v4" stroke="#3b82f6" strokeWidth="1.5"/></svg>
            </div>
            <div>
              <div style={{fontSize:16,fontWeight:700,color:'#0a0a0a'}}>Crear flujo con IA</div>
              <div style={{fontSize:12,color:'#aaa'}}>Describe tu flujo en lenguaje natural — la IA lo construye completo</div>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            {step === 'result' && (
              <button onClick={() => setStep('chat')} style={{padding:'7px 14px',borderRadius:9,border:'1px solid #e8e8e6',background:'#fff',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit',color:'#555'}}>
                ← Volver al chat
              </button>
            )}
            <div onClick={onClose} style={{width:32,height:32,borderRadius:8,border:'1px solid #e8e8e6',background:'#f6f6f4',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',fontSize:18,color:'#888'}}>×</div>
          </div>
        </div>

        {step === 'chat' ? (
          <div style={{display:'flex',flex:1,overflow:'hidden'}}>
            {/* CHAT */}
            <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden'}}>
              <div style={{flex:1,overflow:'auto',padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
                {messages.map((m, i) => (
                  <div key={i} style={{display:'flex',gap:10,alignItems:'flex-start',flexDirection:m.role==='user'?'row-reverse':'row'}}>
                    {m.role==='assistant' && (
                      <div style={{width:30,height:30,borderRadius:50,background:'linear-gradient(135deg,#6ee7b7,#3b82f6)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M12 11V7"/><circle cx="12" cy="5" r="2"/></svg>
                      </div>
                    )}
                    <div style={{
                      maxWidth:'75%',padding:'12px 16px',borderRadius:m.role==='user'?'16px 16px 4px 16px':'16px 16px 16px 4px',
                      background:m.role==='user'?'#0a0a0a':'#f6f6f4',
                      color:m.role==='user'?'#fff':'#0a0a0a',fontSize:13,lineHeight:1.6
                    }}>
                      {m.content.split('**').map((part, pi) => pi%2===1 ? <strong key={pi}>{part}</strong> : <span key={pi}>{part}</span>)}
                    </div>
                  </div>
                ))}
                {loading && (
                  <div style={{display:'flex',gap:10,alignItems:'flex-start'}}>
                    <div style={{width:30,height:30,borderRadius:50,background:'linear-gradient(135deg,#6ee7b7,#3b82f6)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M12 11V7"/><circle cx="12" cy="5" r="2"/></svg>
                    </div>
                    <div style={{padding:'12px 16px',borderRadius:'16px 16px 16px 4px',background:'#f6f6f4',display:'flex',gap:5,alignItems:'center'}}>
                      {[0,1,2].map(i=><div key={i} style={{width:6,height:6,borderRadius:'50%',background:'#bbb',animation:`bounce 1s ${i*0.15}s infinite`}}/>)}
                    </div>
                  </div>
                )}
                <div ref={messagesEndRef}/>
              </div>

              {/* INPUT */}
              <div style={{padding:'16px 24px',borderTop:'1px solid #f0f0ee',flexShrink:0}}>
                <div style={{display:'flex',gap:10}}>
                  <textarea
                    value={input}
                    onChange={e=>setInput(e.target.value)}
                    onKeyDown={e=>{ if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMessage(input);} }}
                    placeholder="Describe el flujo que necesitas... (Enter para enviar)"
                    style={{flex:1,padding:'11px 14px',borderRadius:12,border:'1px solid #e8e8e6',fontSize:13,fontFamily:'inherit',outline:'none',color:'#0a0a0a',resize:'none',height:52,lineHeight:1.5}}
                  />
                  <button onClick={()=>sendMessage(input)} disabled={loading||!input.trim()} style={{width:48,height:52,borderRadius:12,border:'none',background:loading||!input.trim()?'#f0f0ee':'#0a0a0a',color:loading||!input.trim()?'#bbb':'#fff',cursor:loading||!input.trim()?'default':'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all 0.15s'}}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  </button>
                </div>
              </div>
            </div>

            {/* SUGERENCIAS */}
            <div style={{width:280,borderLeft:'1px solid #f0f0ee',padding:'20px',overflow:'auto',flexShrink:0,background:'#fafaf9'}}>
              <div style={{fontSize:11,fontWeight:700,color:'#aaa',textTransform:'uppercase',letterSpacing:'0.08em',marginBottom:14}}>Flujos sugeridos para tu negocio</div>
              {SUGERENCIAS.map((s,i)=>(
                <div key={i} onClick={()=>sendMessage(s)} style={{background:'#fff',border:'1px solid #e8e8e6',borderRadius:10,padding:'10px 12px',marginBottom:8,cursor:'pointer',fontSize:12,color:'#555',lineHeight:1.5,transition:'all 0.15s'}} onMouseEnter={e=>{e.currentTarget.style.borderColor='#0a0a0a';e.currentTarget.style.color='#0a0a0a';}} onMouseLeave={e=>{e.currentTarget.style.borderColor='#e8e8e6';e.currentTarget.style.color='#555';}}>
                  {s}
                </div>
              ))}
              <div style={{marginTop:16,padding:'12px',background:'#fffbeb',borderRadius:10,border:'1px solid #fde68a'}}>
                <div style={{fontSize:11,fontWeight:700,color:'#92400e',marginBottom:4}}>Contexto del negocio</div>
                <div style={{fontSize:11,color:'#78350f',lineHeight:1.5}}>La IA conoce tus 3 tiendas, Coordinadora e IR, plantillas aprobadas, agentes Tatiana y Paola, y tus métodos de pago.</div>
              </div>
            </div>
          </div>
        ) : (
          /* RESULTADO */
          <div style={{flex:1,display:'flex',overflow:'hidden'}}>
            {/* PANEL IZQUIERDO — DIAGRAMA + JSON */}
            <div style={{flex:1,display:'flex',flexDirection:'column',overflow:'hidden',borderRight:'1px solid #f0f0ee'}}>
              {/* TABS RESULTADO */}
              <div style={{display:'flex',borderBottom:'1px solid #f0f0ee',padding:'0 20px',flexShrink:0,background:'#fff'}}>
                {['diagrama','json'].map(t=>(
                  <button key={t} onClick={()=>setActiveTab(t)} style={{padding:'12px 18px',border:'none',background:'transparent',fontSize:13,fontWeight:activeTab===t?600:400,color:activeTab===t?'#0a0a0a':'#aaa',cursor:'pointer',borderBottom:`2px solid ${activeTab===t?'#0a0a0a':'transparent'}`,marginBottom:-1,fontFamily:'inherit',transition:'all 0.15s',textTransform:'capitalize'}}>
                    {t === 'diagrama' ? 'Diagrama del flujo' : 'JSON para n8n'}
                  </button>
                ))}
              </div>

              {activeTab === 'diagrama' && (
                <div style={{flex:1,overflow:'auto',padding:'20px'}}>
                  {/* INFO DEL FLUJO */}
                  <div style={{background:'#f6f6f4',borderRadius:12,padding:'14px 16px',marginBottom:16,display:'flex',gap:20,flexWrap:'wrap'}}>
                    <div><div style={{fontSize:10,color:'#aaa',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.06em'}}>Flujo</div><div style={{fontSize:14,fontWeight:700,color:'#0a0a0a',marginTop:2}}>{flowResult?.nombre}</div></div>
                    <div><div style={{fontSize:10,color:'#aaa',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.06em'}}>Nodos</div><div style={{fontSize:14,fontWeight:700,color:'#0a0a0a',marginTop:2}}>{flowResult?.nodos?.length || 0}</div></div>
                    <div><div style={{fontSize:10,color:'#aaa',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.06em'}}>Config estimada</div><div style={{fontSize:14,fontWeight:700,color:'#0a0a0a',marginTop:2}}>{flowResult?.estimado_configuracion || '—'}</div></div>
                    <div><div style={{fontSize:10,color:'#aaa',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.06em'}}>Variables</div><div style={{fontSize:13,fontWeight:500,color:'#ef4444',marginTop:2}}>{flowResult?.variables_requeridas?.length || 0} requeridas</div></div>
                  </div>

                  {/* NODOS */}
                  <div style={{display:'flex',flexDirection:'column',gap:0}}>
                    {flowResult?.nodos?.map((nodo, i) => {
                      const cfg = NODE_COLORS[nodo.tipo] || NODE_COLORS.accion;
                      const isLast = i === flowResult.nodos.length - 1;
                      return (
                        <div key={nodo.id} style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                          <div style={{background:cfg.bg,border:`1.5px solid ${cfg.border}`,borderRadius:12,padding:'14px 16px',width:'100%',position:'relative'}}>
                            <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                              <div style={{width:8,height:8,borderRadius:'50%',background:cfg.dot,flexShrink:0}}/>
                              <span style={{fontSize:10,fontWeight:700,color:cfg.dot,textTransform:'uppercase',letterSpacing:'0.08em'}}>{cfg.label}</span>
                              <span style={{fontSize:10,color:'#bbb',marginLeft:'auto'}}>{nodo.id}</span>
                            </div>
                            <div style={{fontSize:13,fontWeight:700,color:'#0a0a0a',marginBottom:4}}>{nodo.nombre}</div>
                            <div style={{fontSize:12,color:'#666',lineHeight:1.5}}>{nodo.descripcion}</div>
                            {nodo.config && Object.keys(nodo.config).length > 0 && (
                              <div style={{marginTop:8,background:'rgba(0,0,0,0.04)',borderRadius:8,padding:'8px 10px'}}>
                                {Object.entries(nodo.config).map(([k,v])=>(
                                  <div key={k} style={{display:'flex',gap:8,fontSize:11,marginBottom:2}}>
                                    <span style={{color:'#aaa',fontWeight:500,minWidth:120}}>{k}:</span>
                                    <span style={{color:'#555',fontFamily:'monospace'}}>{typeof v === 'object' ? JSON.stringify(v) : String(v)}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                            {nodo.siguiente?.length > 1 && (
                              <div style={{marginTop:8,display:'flex',gap:6,flexWrap:'wrap'}}>
                                {nodo.siguiente.map(s=>(
                                  <span key={s} style={{fontSize:10,padding:'2px 8px',borderRadius:999,background:'rgba(0,0,0,0.06)',color:'#555',fontWeight:500}}>→ {s}</span>
                                ))}
                              </div>
                            )}
                          </div>
                          {!isLast && (
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',width:40,margin:'0 0 0 20px'}}>
                              <div style={{width:2,height:20,background:'#e8e8e6'}}/>
                              <svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1l5 5 5-5" stroke="#ccc" strokeWidth="1.5" strokeLinecap="round"/></svg>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* VARIABLES REQUERIDAS */}
                  {flowResult?.variables_requeridas?.length > 0 && (
                    <div style={{marginTop:16,background:'#fef2f2',border:'1px solid #fee2e2',borderRadius:12,padding:'14px 16px'}}>
                      <div style={{fontSize:11,fontWeight:700,color:'#ef4444',textTransform:'uppercase',letterSpacing:'0.08em',marginBottom:10}}>Variables de entorno requeridas</div>
                      {flowResult.variables_requeridas.map(v=>(
                        <div key={v} style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                          <div style={{width:6,height:6,borderRadius:'50%',background:'#ef4444'}}/>
                          <code style={{fontSize:12,fontFamily:'monospace',color:'#991b1b',background:'rgba(239,68,68,0.1)',padding:'2px 8px',borderRadius:6}}>{v}</code>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'json' && (
                <div style={{flex:1,overflow:'auto',padding:'20px',position:'relative'}}>
                  <div style={{position:'absolute',top:28,right:28,zIndex:10}}>
                    <button onClick={copyJSON} style={{padding:'7px 14px',borderRadius:8,border:'1px solid #e8e8e6',background:copied?'#f0fdf4':'#fff',color:copied?'#16a34a':'#555',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:5}}>
                      {copied ? <>✓ Copiado</> : <>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                        Copiar JSON
                      </>}
                    </button>
                  </div>
                  <pre style={{fontSize:11,fontFamily:'monospace',color:'#0a0a0a',background:'#f6f6f4',borderRadius:12,padding:'16px',overflow:'auto',lineHeight:1.6,whiteSpace:'pre-wrap',wordBreak:'break-word'}}>
                    {JSON.stringify(flowResult?.n8n_json || flowResult, null, 2)}
                  </pre>
                </div>
              )}
            </div>

            {/* PANEL DERECHO — CHECKLIST */}
            <div style={{width:360,display:'flex',flexDirection:'column',overflow:'hidden',flexShrink:0}}>
              <div style={{padding:'16px 20px',borderBottom:'1px solid #f0f0ee',flexShrink:0}}>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
                  <div style={{fontSize:14,fontWeight:700,color:'#0a0a0a'}}>Pasos de configuración</div>
                  <span style={{fontSize:12,fontWeight:700,color:progress===100?'#16a34a':'#555'}}>{completedSteps}/{totalSteps}</span>
                </div>
                <div style={{height:6,background:'#f0f0ee',borderRadius:999,overflow:'hidden'}}>
                  <div style={{height:'100%',background:progress===100?'#22c55e':'#3b82f6',borderRadius:999,width:`${progress}%`,transition:'width 0.3s'}}/>
                </div>
                {progress === 100 && (
                  <div style={{marginTop:8,fontSize:12,color:'#16a34a',fontWeight:500,display:'flex',alignItems:'center',gap:5}}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
                    ¡Listo para activar!
                  </div>
                )}
              </div>

              <div style={{flex:1,overflow:'auto',padding:'16px 20px'}}>
                {flowResult?.checklist?.map((paso, i) => (
                  <div key={i} onClick={()=>toggleChecklist(i)} style={{display:'flex',gap:12,marginBottom:12,padding:'12px 14px',borderRadius:12,border:`1.5px solid ${checklistDone.includes(i)?'#22c55e':'#e8e8e6'}`,background:checklistDone.includes(i)?'#f0fdf4':'#fff',cursor:'pointer',transition:'all 0.15s'}}>
                    <div style={{width:22,height:22,borderRadius:6,border:`1.5px solid ${checklistDone.includes(i)?'#22c55e':'#ddd'}`,background:checklistDone.includes(i)?'#22c55e':'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,transition:'all 0.15s'}}>
                      {checklistDone.includes(i) && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:4}}>
                        <div style={{display:'flex',alignItems:'center',gap:4}}>
                          {CHECKLIST_ICONS[paso.tipo]}
                        </div>
                        <span style={{fontSize:12,fontWeight:700,color:checklistDone.includes(i)?'#16a34a':'#0a0a0a'}}>
                          {paso.paso}. {paso.titulo}
                        </span>
                        {paso.obligatorio && <span style={{fontSize:9,padding:'1px 6px',borderRadius:999,background:'#fef2f2',color:'#ef4444',fontWeight:700,marginLeft:'auto'}}>Requerido</span>}
                      </div>
                      <div style={{fontSize:11,color:'#888',lineHeight:1.5}}>{paso.descripcion}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* ACCIONES */}
              <div style={{padding:'16px 20px',borderTop:'1px solid #f0f0ee',display:'flex',flexDirection:'column',gap:8,flexShrink:0}}>
                <button onClick={()=>{ onSave && onSave(flowResult); onClose(); }} style={{width:'100%',padding:'11px',borderRadius:10,border:'none',background:'#0a0a0a',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'inherit'}}>
                  Guardar flujo en Talku
                </button>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={copyJSON} style={{flex:1,padding:'9px',borderRadius:10,border:'1px solid #e8e8e6',background:'#fff',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit',color:'#555'}}>
                    Exportar JSON n8n
                  </button>
                  <button onClick={()=>setStep('chat')} style={{flex:1,padding:'9px',borderRadius:10,border:'1px solid #e8e8e6',background:'#fff',fontSize:12,fontWeight:500,cursor:'pointer',fontFamily:'inherit',color:'#555'}}>
                    Ajustar descripción
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <style>{`@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}`}</style>
    </div>
  );
}
